<template>
  <div class="frosted-box">
    <div class="backdrop-container">
      <div class="backdrop"></div>
      <div v-if="edge" class="backdrop-edge"></div>
    </div>
    <div class="content-container">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
withDefaults(
  defineProps<{
    height: string
    position?: string
    edge?: boolean
    top?: string
    bottom?: string
  }>(),
  {
    position: 'sticky',
    top: '0',
  },
)
</script>
<style scoped>
.content-container {
  /* display: flex; */
  /* z-index: 11; */
}
.frosted-box {
  --thickness: 1px;
  --blur: blur(50px);
  top: v-bind(top);
  bottom: v-bind(bottom);
  /* z-index: 0; */
  position: v-bind(position);
  height: v-bind(height);
  width: 100%;
  will-change: transform;
}

@supports (backdrop-filter: var(--blur)) or
  (-webkit-backdrop-filter: var(--blur)) {
  .backdrop {
    position: absolute;
    inset: 0;
    -webkit-backdrop-filter: var(--blur);
    backdrop-filter: var(--blur);
    image-rendering: smooth;
    /* background: linear-gradient(
      to bottom,
      hsla(0deg 0% 95% / 3%),
      transparent 50%
    ); */
    pointer-events: none;
  }

  /* .backdrop::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background-image: url(../../assets/images/noise.jpg);
    mix-blend-mode: overlay;
    opacity: 0.05;
    filter: blur(4px);
    background-size: 64px 64px;
  } */

  .backdrop-edge {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: var(--thickness);
    background: hsl(0deg 0% 100% / 0.1);
    -webkit-backdrop-filter: blur(12px) brightness(0.96);
    backdrop-filter: blur(12px) brightness(0.96);
    transform: translateY(100%);
    pointer-events: none;
  }
}

@supports (mask-image: none) or (-webkit-mask-image: none) {
  .backdrop {
    height: 200%;
    -webkit-mask-image: linear-gradient(
      to bottom,
      black 0% 50%,
      transparent 50% 100%
    );
    mask-image: linear-gradient(to bottom, black 0% 50%, transparent 50% 100%);
    mask-position:
      0 0,
      100% 0;
    mask-repeat: no-repeat, no-repeat;
  }
  .backdrop-edge {
    -webkit-mask-image: linear-gradient(
      to bottom,
      black 0,
      black var(--thickness),
      transparent var(--thickness)
    );
    mask-image: linear-gradient(
      to bottom,
      black 0,
      black var(--thickness),
      transparent var(--thickness)
    );
  }
}
</style>
